import { memo, useMemo } from 'react';
import { Box, Button, formatMoney, Text } from '@betty/moonlight';
import { Trans } from '@betty/i18n';
import { BottomSheetExtendedProps } from '@betty/navigation';

type DepositCompletedProps = BottomSheetExtendedProps & {
  amount: number;
};

function DepositCompleted({ amount, close }: DepositCompletedProps) {
  const cash = useMemo(() => formatMoney(amount), [amount]);

  return (
    <Box alignItems="center" gap="space-600">
      <Text
        variant="h4"
        color="darkSurfacePrimary"
        locNS="wallet"
        locKey="deposit_completed_title"
      />
      <Text variant="body-m" color="darkSurfacePrimary" textAlign="center">
        <Trans
          ns="wallet"
          i18nKey="deposit_completed_message"
          values={{ amount: cash }}
        />
      </Text>
      <Button
        width="100%"
        locNS="wallet"
        locKey="deposit_completed_cta"
        variant="primary"
        onPress={close}
      />
    </Box>
  );
}

export default memo(DepositCompleted);
